<template>
	<ul>
		<li>
			<div style="padding-left: 18px;">
				<CheckboxGroup :class="prefixCls + '-spread'"
					v-model="selected" @on-change="onChange">
			        <Checkbox v-for="(item, i) in spread" :key="i" :label="item.title"
                        :disabled="item.disabled">
			        	<span :class="titleClasses">{{item.title}}</span>
			        </Checkbox>
			    </CheckboxGroup>
			</div>
		</li>
	</ul>
</template>
<script>
	import Checkbox from '../checkbox/checkbox.vue';
	import CheckboxGroup from '../checkbox/checkbox-group.vue';
	import Emitter from '../../mixins/emitter';

	export default {
		name: "TreeSpread",

		mixins: [ Emitter ],

		components: {
			Checkbox,
			CheckboxGroup
		},
		
		props:{
			// 待展开项
			spread: {
                type: Array,
                default () {
                    return [];
                }
            },
		},
		
		data(){
			return {
				// 选中项
				selected: [],
				spreadMap: {},
			}
		},

		computed:{
			prefixCls () {
                return [
                    `ivu-tree`
                ]
            },
            titleClasses () {
                return [
                    `${this.prefixCls}-title`,
                ]
            },
		},

		methods:{
			// action check change
			onChange(selected, target){
				// 通知父级
				var { label, value } = target
				var child = this.spread.find(v => v.title == label)

                const changes = {
                    checked: value,
                    nodeKey: child.nodeKey, // 提供子级，用于查找其父级
                }

                // 更新node data
                this.spreadCheckState(selected)
                // 触发tree更新
                this.dispatch('Tree', 'on-check', changes)
			},

			// 同步spread状态
			spreadCheckState(selected){
				this.spread.forEach(v => {
					if(selected.length > 0 && selected.find(title => title == v.title)){
						this.$set(v, "checked", true)
					} else {
						this.$set(v, "checked", false)
					}
				})
			},
		},

		// 初始化
		mounted(){
			// 监听checked变化，同步更新selected
			this.$watch(function(){
				var count = 0

				this.spread.forEach(v => {
					if(v.checked) count++
				})

				return count
			}, function(){
				this.selected = this.spread.filter(v => v.checked).map(v => v.title)
			}, {
				immediate: true
			})
		},
	}
</script>